export const checkIsRadio = (masterBook) => {
  if (masterBook.length == 0) return false;

  var isRadio = false;
  if (
    masterBook._max_purchase_count[0].limited_type == "master_book" &&
    masterBook._max_purchase_count[0].gettable_counts[0].count == 1
  ) {
    isRadio = true;
  }
  if (masterBook.max_purchase_count == 1) {
    isRadio = true;
  }
  return isRadio;
};
